<div class="container-fluid pt-3 pb-2 h-100">
    <router-outlet></router-outlet>
</div>
